const initialState = () => ({
  users: [],
  creator_users: [],
  pagination: {},
  status: null,
  current: null,
  locations: [],
  mails: [],
  loadingMails: false,
  pass: '',
  message: null,
  info: null,
  hasMetabaseAccess: null
})

export default initialState
